import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import type { AppRole, SecretLevel } from '@infras/shared-types';

/**
 * Server-verified whoami — the canonical role source for the UI (the guard
 * resolved it from app_roles). Capability checks (canSeeInventory, …) come from
 * the shared rbac module so web/api/mcp can never drift.
 */
export const ME = gql`
  query Me {
    me {
      email
      roles
      isAdmin
      role
      allowedLevels
    }
  }
`;

export interface Me {
  email: string;
  roles: string[];
  isAdmin: boolean;
  role: AppRole;
  allowedLevels: SecretLevel[];
}

export function useMe() {
  const { data, loading, error, refetch } = useQuery<{ me: Me }>(ME, {
    fetchPolicy: 'cache-and-network',
  });
  return {
    me: data?.me,
    role: data?.me?.role,
    loading: loading && !data,
    error,
    refetch,
  };
}
